import * as PropTypes from 'prop-types';

export const PayeeData = PropTypes.shape({
  processorsGenericFields: PropTypes.arrayOf(PropTypes.string),
  paypage: PropTypes.string.isRequired,
  vaultUrl: PropTypes.string.isRequired,
  paypageId: PropTypes.string
});
